export default function toggleEditMode(state, payload) {
  const activePlansEdit = state.activePlans.map(plan => ({
    ...plan,
    editMode: plan.id === payload.planId ? !plan.editMode : plan.editMode,
  }));

  const completePlansEdit = state.completePlans.map(plan => ({
    ...plan,
    editMode: plan.id === payload.planId ? !plan.editMode : plan.editMode,
  }));

  return {
    ...state,
    activePlansEdit,
    completePlansEdit,
  };
}